import { MapPin } from "lucide-react";
import { StarRatingDisplay } from "@/components/StarRating";
import { ReviewCard } from "@/components/ReviewCard";

// Pagina di anteprima statica per mostrare come appaiono
// 2 recensioni (genitore + professionista) sulla scheda scuola.
// Solo scopo demo/preview interno. Nessuna chiamata al backend.
export default function AnteprimaSchedaDemo() {
  const school = {
    id: "demo-scuola-xyz",
    name: "Scuola dell'infanzia Il Girasole",
    address: "Via delle Rose 42",
    city: "Cagliari",
    province: "CA",
    type: "paritaria",
    avg_rating: 4.3,
    review_count: 2,
  };

  const nowIso = new Date().toISOString();
  const twoDaysAgo = new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString();

  const reviews = [
    {
      id: "demo-review-parent-1",
      school_id: school.id,
      user_id: "demo-user-parent",
      user_name: "Chiara M.",
      user_picture: null,
      user_slug: null,
      reviewer_role: "genitore",
      rating: 5,
      comment:
        "Nostro figlio frequenta da due anni e ci siamo trovati davvero bene. Le educatrici sono attente, ci aggiornano spesso e riescono a coinvolgere i bambini in tantissime attività. Gli spazi sono ampi e curati. Consigliata!",
      teachers_rating: 5,
      spaces_rating: 4,
      communication_rating: 5,
      food_rating: 3,
      activities_rating: 5,
      would_choose_again: "si",
      created_at: nowIso,
      replies: [],
    },
    {
      id: "demo-review-educator-1",
      school_id: school.id,
      user_id: "demo-user-educator",
      user_name: "Giulia P.",
      user_picture: null,
      user_slug: null,
      reviewer_role: "professionista",
      rating: 4,
      comment:
        "Lavoro qui da tre anni. Cerchiamo ogni giorno di costruire un dialogo aperto con le famiglie e di proporre attività che stimolino la creatività dei bambini. L'organizzazione ci lascia lo spazio giusto per sperimentare progetti nuovi.",
      teachers_rating: 5,
      spaces_rating: 4,
      communication_rating: 4,
      food_rating: 4,
      activities_rating: 5,
      would_choose_again: "si",
      created_at: twoDaysAgo,
      replies: [],
    },
  ];

  return (
    <main className="max-w-5xl mx-auto px-4 py-10">
      {/* Banner demo */}
      <div className="mb-8 p-4 rounded-md bg-[#FAF3E7] border border-[#C05C45]/25 font-ui text-sm text-[#1A362D]">
        <p className="font-medium mb-1">👀 Anteprima demo</p>
        <p className="text-[#5C6B64]">
          Questa pagina simula la scheda di una scuola con due recensioni: una di un
          <strong> genitore</strong> e una di un&apos;<strong>professionista dell&apos;infanzia</strong>. È solo per farti vedere come
          appariranno i badge e le domande sulla scheda pubblica. Nessun dato reale.
        </p>
      </div>

      {/* Header scuola (semplificato) */}
      <section className="card-surface p-6 mb-8" data-testid="demo-school-header">
        <p className="label-eyebrow text-[#C05C45]">
          {school.type === "paritaria" ? "Scuola paritaria/privata" : "Scuola pubblica"}
        </p>
        <h1 className="mt-2 font-display text-4xl text-[#1A362D] tracking-tight">{school.name}</h1>
        <div className="mt-2 flex items-center gap-2 font-ui text-sm text-[#5C6B64]">
          <MapPin size={14} />
          <span>{school.address}, {school.city} ({school.province})</span>
        </div>
        <div className="mt-3 flex items-center gap-3">
          <StarRatingDisplay value={school.avg_rating} size={18} />
          <span className="font-ui text-sm text-[#1A362D]">
            <strong>{school.avg_rating.toFixed(1)}</strong> su {school.review_count} esperienze
          </span>
        </div>
      </section>

      {/* Sezione esperienze */}
      <section>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
          <h2 className="font-display text-3xl text-[#1A362D] tracking-tight">
            Le esperienze di genitori e professionisti
          </h2>
          <button className="btn-primary text-sm sm:text-base whitespace-nowrap" disabled>
            Racconta la tua esperienza
          </button>
        </div>
        <div className="space-y-4">
          {reviews.map((r) => (
            <ReviewCard key={r.id} review={r} />
          ))}
        </div>
      </section>
    </main>
  );
}
